export const fieldStructure = (type, label = '', name = '') => {
	let field = {
		type: `${type}`,
		label: label,
		info: '',
		variable: {
			name: name,
		},
		initialValue: '',
		optional: false,
	}

	switch (type) {
		case 'time':
			field.variable.type = 'time'
			field.minute_step = ''
			break
		case 'number':
			field.variable.type = 'number'
			field.variable.doc_display_style = 'plain'
			field.decimals = ''
			field.min = ''
			field.max = ''
			field.step = ''
			break
		case 'date':
			field.variable.type = 'date'
			field.variable.doc_display_style = '%d/%m/%Y'
			break
		case 'checkbox':
			field.variable.type = 'list'
			field.variable.doc_display_style = 'commas'
			break
		case 'currency':
			field.initialValue = 0
			field.variable.type = 'currency'
			field.variable.doc_display_style = 'plain'
			break
		case 'database':
			field.remove_autocomplete = false
			field.variable.type = 'database'
			field.variable.api_endpoint = ''
			field.variable.search_key = ''
			field.variable.display_key = ''
			break
		case 'api':
			field.variable.type = 'api'
			field.variable.api_endpoint = ''
			field.variable.list_object_property = 'apiFieldItem'
			break
		case 'variable_image':
			field.multiple = false
			field.variable.type = 'variable_image'
			field.variable.doc_display_style = 'image'
			field.variable.width = 8.0
			break
		case 'attachment':
			field.multiple = false
			field.variable.type = 'attachment'
			break
		case 'person':
			field.person_list = false
			field.variable.type = 'person'
			field.person_type = ['legal_person', 'natural_person']
			field.fields = [
				'nationality',
				'cpf',
				'pronoun',
				'name',
				'surname',
				'identity',
				'identity_org',
				'identity_date',
				'email',
				'marital_state',
				'property_regime',
				'profession',
				'legal_nationality',
				'cnpj',
				'society_name',
				'activity',
				'cep',
				'country',
				'number',
				'street',
				'complement',
				'state',
				'district',
				'city',
				'attorney_nationality',
				'attorney_cpf',
				'attorney_pronoun',
				'attorney_name',
				'attorney_surname',
				'attorney_identity',
				'attorney_identity_org',
				'attorney_identity_date',
				'attorney_email',
				'attorney_profession',
				'attorney_cep',
				'attorney_country',
				'attorney_number',
				'attorney_street',
				'attorney_complement',
				'attorney_state',
				'attorney_district',
				'attorney_city',
			]
			field.initialValue = field.fields.reduce(
				(a, field) => ({ ...a, [field]: '' }),
				{ person_type: '' }
			)

			field.designatedPerson = ''
			delete field['info']
			break
		case 'address':
			field.variable.type = 'address'
			field.fields = [
				'cep',
				'country',
				'number',
				'street',
				'complement',
				'district',
				'state',
				'city',
			]

			field.initialValue = field.fields.reduce(
				(a, field) => ({ ...a, [field]: '' }),
				{}
			)

			delete field['info']
			break
		case 'structured_list':
			field.variable.type = type
			field.variable.doc_display_style = 'text'
			field.variable.extra_style_params = {
				row_template: '',
				separator: '',
			}
			field.structure = [
				{
					type: 'text',
					label: '',
					info: '',
					optional: false,
					placeholder: '',
					variable: {
						name: '',
						type: 'string',
						doc_display_style: '',
					},
				},
			]
			break
		case 'structured_checkbox':
			field.variable.type = type
			field.variable.doc_display_style = 'text'
			field.variable.extra_style_params = {
				row_template: '',
				separator: '',
			}
			field.structure = [
				{
					type: 'text',
					label: '',
					info: '',
					variable: {
						name: '',
						type: '',
						doc_display_style: '',
					},
				},
			]
			break
		case 'separator':
			field = {
				type: 'separator',
				title: '',
			}
			break
		case 'description':
			field = {
				type: type,
				title: '',
			}
			break
		case 'text_database':
			field.variable.type = 'text_database'
			field.databaseId = ''
			field.filter = []

			delete field['initialValue']
			delete field['info']
			break
		case 'internal_database':
			field.variable.type = 'internal_database'
			field.databaseId = ''
			field.filter = []
			field.typeWidget = 'list'
			field.minimum = ''
			field.maximum = ''

			delete field['initialValue']
			delete field['info']
			break
		case 'text':
			field.placeholder = ''
			field.variable.type = 'string'
			field.variable.doc_display_style = 'plain'
			break
		case 'text_area_ckeditor':
			field.variable.type = 'text_area_ckeditor'
			field.prompt = ''
			break
		default:
			field.variable.type = 'string'
			field.variable.doc_display_style = 'plain'
			break
	}

	const hasOptions = ['dropdown', 'radio', 'checkbox', 'structured_checkbox']
	if (hasOptions.includes(type)) {
		field.options = [
			{ label: '', value: '' },
			{ label: '', value: '' },
			{ label: '', value: '' },
		]
	}

	return field
}
